<template>
  <div>
    <!-- 视频分类列表页面-->
    <!-- 文艺类视频 -->
    <!-- 高级搜索 -->
    <!-- 【mobile】 -->
    <!-- <template v-if="isMobile">
      <Search></Search>
    </template>-->
    <!-- 【pc】 -->
    <template>
      <div class="v-top-title">
        <span
          :id="index"
          :class="[index == activeId ? 'activeColor': '']"
          v-for="(item,index) in tabs"
          :key="item.id"
          @click="checkTab($event,item.id)"
        >{{item.name}}</span>
        <!-- <span>成片数据</span>
        <span>素材数据</span>-->
      </div>
      <div class="v_topsearch">
        <el-row :gutter="50">
          <el-col :span="12" class="flex-row">
            <div class="tac align-center-vertical">检索类型：</div>
            <div class="cc" style="flex:1;">
              <el-select
              @keyup.enter.native="submitSearch"
                class="div-input-border"
                @change="selectVidelOneValue"
                default-first-option
                multiple
                clearable
                v-model="videoOneValue"
                placeholder="请选择检索类型"
              >
                <el-option
                  v-for="item in videoOneCate"
                  :key="item.id"
                  :label="item.title"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="12" class="flex-row">
            <div class="tac align-center-vertical">门类检索：</div>
            <div class="cc" style="flex:1;">
              <el-select
              @keyup.enter.native="submitSearch"
              class="div-input-border"
                default-first-option
                filterable
                allow-create
                multiple
                clearable
                @change="selectCategory"
                v-model="videoCategory"
                placeholder="请输入或选择门类"
              >
                <el-option
                  v-for="item in videoTwoCate"
                  :key="item.id"
                  :label="item.title"
                  :value="item.title"
                ></el-option>
              </el-select>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12" class="flex-row">
            <div class="align-center-vertical">活动检索：</div>
            <div style="flex:1;">
              <el-input
              @keyup.enter.native="submitSearch"
               class="div-input-border"
                @change="inputActiveName"
                placeholder="请输入活动名称"
                clearable
                v-model="activeName"
              ></el-input>
            </div>
          </el-col>
          <el-col :span="12" class="flex-row">
            <div class="align-center-vertical">人物检索：</div>
            <div style="flex:1;">
              <el-select
              @keyup.enter.native="submitSearch"
               class="div-input-border"
                @change="selectPersonName"
                placeholder="请输入或选择人物"
                filterable
                allow-create
                multiple
                clearable
                v-model="personNameLike"
              >
                <el-option
                  v-for="item in videoPerson"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name"
                ></el-option>
              </el-select>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12" class="flex-row">
            <div class="align-center-vertical">地点检索：</div>
            <div style="flex:1;">
              <el-cascader
              @keyup.enter.native="submitSearch"
               class="div-input-border"
                @change="selectAddress"
                style="width:100%;"
                v-model="address"
                :options="options"
                :props="{ checkStrictly: true,value: 'label' }"
                clearable
              ></el-cascader>
            </div>
          </el-col>
          <el-col :span="12" class="tal flex-row">
            <div class="align-center-vertical">机构检索：</div>
            <div style="flex:1;">
              <el-cascader
              @keyup.enter.native="submitSearch"
               class="div-input-border"
                v-show="isInput"
                @change="selectOrganzation"
                v-model="orgvalue"
                allow-create
                placeholder="请选择机构名称"
                style="width:96%;"
                :options="organizationList"
                :props="{multiple: false,value:'title'}"
              ></el-cascader>
              <el-input
              @keyup.enter.native="submitSearch"
                clearable
                v-model="organizationLike"
                style="width:96%;"
                placeholder="请输入机构名称"
                v-show="!isInput"
              ></el-input>
            </div>
            <el-button type="warning" plain class="" size="mini" @click="checkIsInput">切换</el-button>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col :span="2">
            <div>机构检索：</div>
          </el-col>
          <el-col :span="22" class="tal">
            <div>
              <el-cascader :options="organizationList" :props="{multiple: false,value:'title'}"></el-cascader>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="2">
            <div>地点检索：</div>
          </el-col>
          <el-col :span="22" class="tal">
            <el-cascader
              @change="selectAddress"
              v-model="address"
              :options="options"
              :props="{ checkStrictly: true,value: 'label' }"
              clearable
            ></el-cascader>
          </el-col>
        </el-row>-->
        <el-row :gutter="50">
          <el-col :span="12" class="flex-row">
            <div class="align-center-vertical">时间检索：</div>
            <div style="flex:1;" class="div-input-border">
              <el-date-picker
              @keyup.enter.native="submitSearch"
                class="select-date-border"
                style="width:100%;"
                @change="selectDate"
                v-model="videoDate"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </div>
          </el-col>
          <el-col :span="12" class="tal flex-row">
            <!-- <el-date-picker
              @change="selectDate"
              v-model="videoDate"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            ></el-date-picker>-->
            <div class="align-center-vertical">综合检索：</div>
            <div style="flex:1;">
              <el-input @keyup.enter.native="submitSearch" class="div-input-border" clearable @change="inputRet" placeholder="名称 / 标签 / 简介" v-model="retrieval"></el-input>
              <!-- <div style="color:#ccc;margin-top:15px;" class="f12">多关键词请使用空格隔开</div> -->
            </div>
          </el-col>
        </el-row>
        <!-- <el-row :gutter="50">
          <el-col :span="12" class="flex-row">
            <div class="align-center-vertical">综合检索：</div>
            <div style="flex:1;">
              <el-input placeholder="名称 / 标签 / 简介" v-model="retrieval"></el-input>
              <div style="color:#ccc;margin-top:15px;" class="f12">多关键词请使用空格隔开</div>
            </div>
          </el-col>
          <el-col :span="12" class="tal">

          </el-col>
        </el-row>-->
        <div class="tar searchBtn">
          <div class="fl">
            结果显示模式：
            <el-radio-group v-model="showMode" @change="selectMode">
              <el-radio-button label="0">按单视频</el-radio-button>
              <el-radio-button label="1">按视频集</el-radio-button>
            </el-radio-group>
          </div>

          <el-button class="el-icon-search" @click="submitSearch">检索</el-button>
          <el-button @click="reset">重置</el-button>
        </div>
      </div>

      <!-- 面包屑导航 -->
      <div class="nav_bread" id="nav_bread">
        <el-row>
          <el-col :span="12">
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
              <el-breadcrumb-item>视频列表</el-breadcrumb-item>
              <!-- <el-breadcrumb-item>专题分类1</el-breadcrumb-item> -->
            </el-breadcrumb>
          </el-col>
          <el-col :span="12" class="tar f16">
            共检索
            <span style="color:#11b0ff;">{{total}}</span> 个结果
            <!-- <span>
              (成片
              <span style="color:#11b0ff;">{{total}}</span> 个 / 素材
              <span style="color:#11b0ff;">{{total}}</span> 个)
            </span>-->
            <div class="fr nav-right-tab">
              <div
                @click="clickNavLeft"
                :class="activeClass"
                style="border-right: 1px solid #ccc;
        line-height: 34px;padding:2px;"
              >
                <i class="el-icon-menu"></i>
              </div>
              <div
                @click="clickNavRight"
                :class="navRightClass"
                style="text-align:center;padding:2px;"
              >
                <el-image :src="navSrc"></el-image>
              </div>
            </div>
          </el-col>
        </el-row>

      </div>

      <!-- 视频列表 -->
      <div v-if="isShowList" class="video-list">
        <el-row class="" style="background:#fff;padding:20px 0px 0px 20px;">
          <el-button @click="goUpPage">上一页</el-button>
          <span>-</span>
          <el-button @click="goNextPage">下一页</el-button>
        </el-row>
        <videoList v-if="showMode == 0 && isListMode == 1" :parentList="videoList"></videoList>
        <videoListLeft v-if="showMode == 0 && isListMode == 0" :parentList="videoList" />

        <VideoColl v-if="showMode == 1 && isListMode == 1" :parentList="videoList" />
        <videoCollLeft v-if="showMode == 1 && isListMode == 0" :parentList="videoList" />

        <div class="tar" style="background:#fff;padding:20px 30px;">
          <el-pagination
            @current-change="handleCurrentChange"
            :page-size="limit"
            :current-page.sync="page"
            background
            layout="prev, pager, next, jumper"
            :total="total"
            v-if="total != 0"
          ></el-pagination>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import common from '../../../utils/common.utils'
import Search from '../../mobile/search'
import map from '../../../../static/json/district.json'
import videoList from '../videolist/videolist'
import videoListLeft from '../videolist/videolist2'
import VideoColl from '../videolist/videocollection'
import videoCollLeft from '../videolist/videocollection2'

import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  components: {
    videoList,
    VideoColl,
    Search,
    videoListLeft,
    videoCollLeft
  },
  data: function () {
    return {
      isInput: true,
      activeId: '0',
      isListMode: 1, // 显示模式 0 为组合，1为列表
      activeClass: '',
      navRightClass: 'nav-active',
      navSrc: require('../../../assets/img/icon/navlist2.png'),
      navSrc1: require('../../../assets/img/icon/navlist.png'),
      navSrc2: require('../../../assets/img/icon/navlist2.png'),
      isMobile: false, // 是手机还是pc
      isShowList: false, // 是否显示列表
      isChecked1: true,
      isChecked2: false,
      status: '', // 选择是单视频，还是视频集
      page: 1,
      title: '', // 搜索标题
      total: 0, // 分页总数
      limit: 10,
      videoList: [
        {
          id: 0,
          imgUrl: require('../../../assets/img/06.png')
        },
        {
          id: 1,
          imgUrl: require('../../../assets/img/06.png')
        },
        {
          id: 2,
          imgUrl: require('../../../assets/img/06.png')
        },
        {
          id: 3,
          imgUrl: require('../../../assets/img/06.png')
        },
        {
          id: 4,
          imgUrl: require('../../../assets/img/06.png')
        },
        {
          id: 5,
          imgUrl: require('../../../assets/img/06.png')
        }
      ],
      // ---高级检索--最新
      tabs: [
        {
          id: 0,
          name: '全部数据'
        },
        {
          id: 1,
          name: '成片库'
        },
        {
          id: 2,
          name: '素材库'
        }
      ],
      options: map, // 地点数组
      videoTypeId: '', // 0素材1成片
      videoCategory: [], // 文艺门类
      videoOneValue: [], // 检索类型
      activeName: '', // 活动检索
      address: [], // 地点检索
      addressString: '',
      personNameLike: '', // 人物检索
      organizationLike: '', // 机构检索
      orgvalue: [],
      retrieval: '', // 综合检索
      showMode: '0', // 结果显示模式
      // 门类输入检索
      inputVisible: false,
      inputValue: '',
      // ---
      // // 文艺门类
      // videoTwoCate: [{}],
      // 检索类型
      videoOneCate: [
        {
          id: 0,
          title: '新闻类',
          value: 'NEWS'
        },
        {
          id: 1,
          title: '直播类',
          value: 'LIVE'
        },
        {
          id: 2,
          title: '访谈类',
          value: 'VIEW'
        },
        {
          id: 3,
          title: '作品',
          value: 'WORKS'
        },
        {
          id: 4,
          title: '其他',
          value: 'OTHER'
        }
      ],
      videoDate: [], // 时间检索
      // // 相关人物
      videoPerson: ['人名1', '人民2'],
      // 机构列表
      organizationList: [{}]
    }
  },
  computed: mapState({
    videoTwoCate: 'videoTwoCate',
    searchData: 'searchData'
  }),
  methods: {
    // 页码重置1
    resetPage(){
      this.page = 1
    },
    // 
    goUpPage () {
      this.page--
      this.$store.state.searchData.page--
      this.submitSearch()
    },
    goNextPage () {
      this.page++
      this.$store.state.searchData.page++
      this.submitSearch()
    },
    // 选择门类
    selectCategory: function () {
      this.page = 1
      // this.searchData.videoCategory = this.videoCategory;
    },
    // 选择检索类型
    selectVidelOneValue: function () {
      this.page = 1
      // this.searchData.videoOneValue = this.videoOneValue;
    },
    // 活动检索
    inputActiveName: function () {
      this.page = 1
      // this.searchData.activeName = this.activeName;
    },
    // 选择人物
    selectPersonName: function () {
      this.page = 1
      // this.searchData.personNameLike = this.personNameLike;
    },
    // 综合检索
    inputRet: function () {
            console.log(this.page,'222222')

      this.page = 1
            console.log(this.page,'33333')

      // this.searchData.retrieval = this.retrieval;
    },
    // 去除空数组
    threeData: function (data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].children.length === 0) {
          data[i].children = null
        } else {
          this.threeData(data[i].children)
        }
      }
      return data
    },
    // 点击切换排列顺序
    clickNavLeft: function () {
      this.activeClass = 'nav-active'
      this.navRightClass = ''
      this.navSrc = this.navSrc1
      this.isListMode = 0
      this.submitSearch()
    },
    clickNavRight: function () {
      this.activeClass = ''
      this.navRightClass = 'nav-active'
      this.navSrc = this.navSrc2
      this.isListMode = 1
      this.submitSearch()
    },
    //   查看详情
    // goVideoDetail: function(id) {
    //   this.$router.push({
    //     path: "/videodetail2",
    //     query: {
    //       id: id
    //     }
    //   });
    // },
    //   分页
    handleCurrentChange: function (val) {
      this.page = val
      this.$store.state.searchData.page = val
      this.submitSearch()
      document.querySelector('#nav_bread').scrollIntoView(true)
    },
    //   搜索
    selectValue: function () {
      // console.log(this.title)
    },
    select: function () {
      this.page = 1
      // this.getMatterVideoList();
    },
    //   单视频 视频集
    handleCheck1: function () {
      if (this.isChecked1) {
        this.isChecked2 = false
        this.status = 'SINGLE'
      } else {
        this.status = ''
      }
    },
    handleCheck2: function () {
      if (this.isChecked2) {
        this.isChecked1 = false
        this.status = 'LIST'
      } else {
        this.status = ''
      }
    },
    //   获取素材类视频列表
    getMatterVideoList: async function () {
      // var res = await this.$http.get(
      //   `/v1/videoInfo/materialVideoList?page=${this.page}&limit=${this.limit}&status=${this.status}&title=${this.title}`
      // );
      // var { code, data, total } = res.data;
      // if (code == 0) {
      //   this.videoList = data;
      //   this.total = total;
      // }
    },
    // 【门类检索】 获取文艺类视频的二级分类
    // getTypeList: async function() {
    //   var res = await this.$http.get("/v1/index/videoTypeList");
    //   var { code, data } = res.data;
    //   if (code == 0) {
    //     this.videoTwoCate = data;
    //   }
    // },
    // 选择视频类别
    // selectCate: function(index, item) {
    //   console.log(this.aaa);
    //   console.log(index);
    //   if (this.aaa == index) {
    //     this.aaa = null;
    //     this.videoSource = "";
    //     return;
    //   }
    //   this.aaa = index;
    //   this.videoSource = item;
    // },
    // 选择视频格式
    // selectType: function(index) {
    //   if (this.bbb == index) {
    //     this.bbb = null;
    //     return;
    //   }
    //   this.bbb = index;
    // },
    // 选择文艺分类
    // selectTwoCate: function(index, item) {
    //   if (this.ccc == index) {
    //     this.ccc = null;
    //     this.videoTypeLike = "";
    //     return;
    //   }
    //   this.ccc = index;
    //   this.videoTypeLike = item;
    // },
    selectDate: function () {
      this.page = 1
      if (this.videoDate == null) {
        this.videoDate = []
      }
    },
    // 相关人物列表
    getVideoPersonList: async function () {
      var res = await this.$http.get(`/v1/index/videoPersonList`)
      var { code, message, data } = res.data
      if (code == 0) {
        this.videoPerson = data
      }
    },
    // 机构列表
    getOrganizationList: async function () {
      var res = await this.$http.get(`/v1/index/organizationList`)
      var { code, data, message } = res.data
      if (code == 0) {
        this.organizationList = this.threeData(data)
      }
    },
    // 搜索
    submitSearch: async function () {
      console.log('submit////////', this.$store.state.isBack)
      // if (this.$store.state.isBack == true) {
      //   this.page = this.searchData.page
      // }
      if (this.videoDate == null) {
        this.videoDate = []
        this.videoDate[0] = ''
        this.videoDate[1] = ''
      }
      var res = await this.$http.get(
        `/v1/index/highSearch?page=${this.page}&limit=${
          this.limit
        }&videoTypeId=${this.videoTypeId}&videoCreateBeginTime=${this
          .videoDate[0] || ''}&videoCreateEndTime=${this.videoDate[1] ||
          ''}&videoCategory=${this.videoCategory}&personNameLike=${
          this.personNameLike
        }&organizationLike=${this.organizationLike}&status=${
          this.showMode
        }&retrieval=${this.retrieval}&address=${
          this.addressString
        }&contentType=${this.videoOneValue}&activityTitle=${this.activeName}`
      )
      var { code, message, data } = res.data
      if (code == 0) {
        this.total = data.recordCount
        this.isShowList = true
        this.videoList = data.recordList
        //
        this.searchData.videoCategory = this.videoCategory
        this.searchData.videoOneValue = this.videoOneValue
        this.searchData.activeName = this.activeName
        this.searchData.personNameLike = this.personNameLike
        this.searchData.retrieval = this.retrieval
        this.searchData.orgvalue = this.orgvalue
        this.searchData.organizationLike = this.organizationLike
        this.searchData.showMode = this.showMode
        this.searchData.address = this.address
        this.searchData.videoDate = this.videoDate
        setTimeout(() => {
          document.querySelector('#nav_bread').scrollIntoView(true)
        }, 200)
      }
    },
    // 重置
    reset: function () {
      this.aaa = null
      this.bbb = null
      this.ccc = null
      this.address = [] // 地点检索
      this.addressString = ''
      this.page = 1
      this.videoTypeId = ''
      this.videoOneValue = '' // 检索类型
      this.videoDate = [] // 时间检索
      this.videoCategory = '' // 门类检索
      this.activeName = '' // 活动检索
      this.personNameLike = '' // 人物检索
      this.organizationLike = ''
      this.orgvalue = [] // 机构检索
      this.retrieval = '' // 综合检索
      this.$store.commit('clearSearchObj')
      setTimeout(() => {
        this.submitSearch()
      }, 200)
    },
    // ---选择类别
    checkTab: function (e, id) {
      this.page = 1
      this.activeId = id
      if (id == 0) {
        this.searchData.videoTypeId = ''
        this.videoTypeId = ''
        return false
      }
      if (id == 1) {
        //  成片
        this.searchData.videoTypeId = '1'
        this.videoTypeId = '1'
        return false
      }
      if (id == 2) {
        // 素材
        this.searchData.videoTypeId = '0'
        this.videoTypeId = '0'
        return false
      }
    },
    //
    selectMode: function () {
      this.page = 1
      this.submitSearch()
    },
    // 门类检索
    // showInput() {
    //   this.inputVisible = true;
    //   this.$nextTick(_ => {
    //     this.$refs.saveTagInput.$refs.input.focus();
    //   });
    // },

    // handleInputConfirm() {
    //   let inputValue = this.inputValue;
    //   if (inputValue) {
    //     this.dynamicTags.push(inputValue);
    //   }
    //   this.inputVisible = false;
    //   this.inputValue = "";
    // },
    // 地点选择
    selectAddress: function () {
      this.page = 1
      this.addressString = this.address.join('')
    },
    // 机构选择
    selectOrganzation: function () {
      this.page = 1
      this.organizationLike = this.orgvalue.join('')
    },
    checkIsInput: function () {
      this.isInput = !this.isInput
      if (this.isInput) {
        this.organizationLike = ''
      } else {
        this.organizationLike = ''
        this.orgvalue = []
      }
    },
    // 数据回显
    echoData: function () {
      // console.log('vuex:searchData', this.searchData)
      this.videoDate = this.searchData.videoDate // 时间检索
      this.address = this.searchData.address // 地点检索
      this.addressString = this.searchData.address.join('')
      // this.page = this.searchData.page;
      if (this.$store.state.isBack == true) {
        this.page = this.searchData.page
      } else {
        this.page = 1
      }
      this.videoTypeId = this.searchData.videoTypeId
      if (this.searchData.videoTypeId == '') {
        this.activeId = 0
      } else if (this.searchData.videoTypeId == 1) {
        this.activeId = 1
      } else {
        this.activeId = 2
      }
      this.videoOneValue = this.searchData.videoOneValue // 检索类型
      this.videoCategory = this.searchData.videoCategory // 门类检索
      this.activeName = this.searchData.activeName // 活动检索
      this.personNameLike = this.searchData.personNameLike // 人物检索
      if (this.searchData.orgvalue !== []) {
        this.isInput = true
        this.orgvalue = this.searchData.orgvalue // 机构检索
      }
      if (this.searchData.organizationLike) {
        this.isInput = false
        this.organizationLike = this.searchData.organizationLike // 机构输入
      }

      this.retrieval = this.searchData.retrieval // 综合检索
      this.submitSearch()
    },
    // 监听刷新
    beforeUpload: function (e) {
      this.isShowList = false
    },
    // 首页更多跳转 加载数据
    highSearchShow () {

      if (this.$route.query.vv != undefined) {
        this.videoTypeId = this.$route.query.vv
        switch (this.$route.query.vv) {
          case 1:
            this.activeId = 1
            break
          case 0:
            this.activeId = 2
            break
        }
        this.submitSearch()
      }
    }

  },
  mounted: function () {
    this.highSearchShow()

    this.isShowList = this.$route.query.from != 0
    if (this.isShowList) {
      this.submitSearch()
    }
    this.isMobile = common._isMobile()

    this.getVideoPersonList()
    this.getOrganizationList()

    this.$store.dispatch('getTypeList')
    this.$store.dispatch('getPersonList')
  },
  created: function () {
    // 判断是手机还是移动端
    if (common._isMobile()) {
      this.$router.push('/highsearch')
      this.$store.state.activeId = 1
    }
  },
  destroyed () {
    this.$store.state.isBack = false
  },
  watch: {

    page: function () {
      // console.log('ppppppppp', this.page)
    },
    retrieval: function () {
      if (this.retrieval == '') {
        var url = window.location.href // 获取当前页面的url
        if (url.indexOf('?') != -1) {
          // 判断是否存在参数·
          // url = url.replace(/(\?|#)[^'"]*/, ""); //去除参数
          url = url.split('?')[0]
          window.history.pushState({}, 0, url)
        }
      }
    }

  },
  beforeRouteLeave (to, from, next) {
    // console.log(to.path);
    next()
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (from.path == '/videodetail2') {
        if (vm.$route.query.videoTypeId == 0) {
          // 素材
          vm.activeId = 2
          vm.videoTypeId = 0
          vm.submitSearch()
        } else if (vm.$route.query.videoTypeId == 1) {
          // 成片
          vm.activeId = 1
          vm.videoTypeId = 1
          vm.submitSearch()
        } else if (vm.$route.query.typeName || vm.$route.query.retrieval) {
          if (vm.$route.query.typeName) {
            vm.videoCategory.push(vm.$route.query.typeName)
          }
          if (vm.$route.query.retrieval) {
            vm.retrieval = vm.$route.query.retrieval
          }
          vm.submitSearch()
        } else {
          vm.showMode = vm.$store.state.isModeStatus
          // 回显;
          vm.echoData()
        }
      }
      if (from.path == '/home') {
        if (vm.$route.query.isClear == 0) {
          vm.$store.commit('clearSearchObj')
        } else {
          if (vm.$route.query.typeName) {
            vm.videoCategory.push(vm.$route.query.typeName)
            vm.submitSearch()
          }
          if (vm.$route.query.retrieval) {
            vm.retrieval = vm.$route.query.retrieval
            vm.submitSearch()
          }
          document.querySelector('#nav_bread').scrollIntoView(true)
        }
      }
      if (from.path == '/searchpages') {
        if (vm.$route.query.cate && vm.$route.query.type) {
          vm.videoCategory.push(vm.$route.query.cate)
          vm.videoOneValue.push(vm.$route.query.type)
          vm.submitSearch()
        }
        if (vm.$route.query.videoTypeId == 0) {
          // 素材
          vm.activeId = 2
          vm.videoTypeId = 0
          vm.submitSearch()
        } else if (vm.$route.query.videoTypeId == 1) {
          // 成片
          vm.activeId = 1
          vm.videoTypeId = 1
          vm.submitSearch()
        } else if (vm.$route.query.typeName || vm.$route.query.retrieval) {
          if (vm.$route.query.typeName) {
            vm.videoCategory.push(vm.$route.query.typeName)
          }
          if (vm.$route.query.retrieval) {
            vm.retrieval = vm.$route.query.retrieval
          }
          vm.submitSearch()
        } else {

        }
      }
    })
  }
}
</script>

<style scoped lang="scss">
@import "./topsearch.scss";
// 顶部
.activeColor {
  border-bottom: 2px solid #00aaff;
  color: #00aaff !important;
}
// 面包屑导航
.nav_bread {
  border-bottom: 1px solid #e9e9e9;
  padding: 0 20px;
  width: 1200px;
  margin: 0 auto;
  height: 80px;
  line-height: 80px;
  background-color: #fff;
  .el-breadcrumb {
    height: 80px;
    line-height: 80px;
  }
  .el-input {
    width: 200px;
    margin-right: 20px;
  }
  .nav-right-tab {
    margin: 20px;
    display: flex;
    flex-direction: row;
    justify-content: center;

    width: 80px;
    height: 40px;
    line-height: 40px;
    border: 1px solid #ccc;
    background-color: #fff;
    border-radius: 5px;
    .nav-active {
      .el-icon-menu {
        color: #00aaff;
      }
      border: 1px solid #00aaff !important;
    }
    div {
      width: 100%;
      height: 100%;
      text-align: center;
      &:first-child {
        // border-right: 1px solid #ccc;
        // line-height: 35px;
      }
      .el-icon-menu {
        font-size: 20px;
        vertical-align: middle;
      }
    }
  }
}
.video-list {
  width: 1200px;
  margin: 0 auto;
  li {
    position: relative;
    margin-top: 20px;
    width: 23.5%;
    float: left;
    height: 300px;
    margin-right: 2%;
    &:nth-child(4n) {
      margin-right: 0px;
    }
    .el-image {
      width: 100%;
      height: 200px;
      border: 1px solid #ccc;
    }
    p {
      margin-top: 20px;
      text-align: center;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .videocount {
      position: absolute;
      top: 8px;
      right: 10px;
      width: auto;
      height: 20px;
      border-radius: 10px;
      font-size: 12px;
      padding: 0px 8px;
      border: 1px solid #ccc;
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/videotype/videolist.vue